
import { fetchWithBearerToken } from '../utils/utils';

export function getRandomQuote(cahceCallback) {

    return fetchWithBearerToken(
        process.env.REACT_APP_URL_API_QUOTE_GET_RANDOM_QUOTE,
        "GET", null, cahceCallback)
        .then(response => response);
}